export default __webpack_public_path__ + "static/media/CNo.65-5.655d0d46.jpg";